import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import PopoverIconLight from '../../../../Popover/PopoverIconLight';

export interface Props {
  content: React.JSX.Element;
}

const PopoverContent: React.FC<Props> = ({ content }) => (
  <div
    className={clsx(
      'absolute w-60 p-2 border-[1px] bg-white text-sm z-10',
      'ml-[-6rem] mt-2 rounded-md border-solid border-gray-300 text-gray-800',
      'shadow-[0px_6px_20px_-2px_rgba(26,26,26,0.14),0px_4px_6px_rgba(26,26,26,0.06)]',
    )}
  >
    <div className="absolute left-28 top-[-7px]">
      <PopoverIconLight />
    </div>
    {content}
  </div>
);

export default observer(PopoverContent);
